import React, { useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useTheme } from '../redux/hooks/useTheme';
import { themeConfig } from './theme';

export const ThemeProvider = ({ children }) => {
  const { themeMode } = useTheme();
  
  // Get the appropriate palette based on theme mode
  const currentPalette = themeMode === 'light' ? themeConfig.palette.light : themeConfig.palette.dark;
  
  // Create MUI theme based on current mode
  const muiTheme = createTheme({
    ...themeConfig,
    palette: {
      ...themeConfig.palette,
      mode: themeMode,
      // Apply the current mode's palette
      ...currentPalette,
      // Ensure action colors are properly set for the current mode
      action: {
        active: currentPalette.action.active,
        hover: currentPalette.action.hover,
        selected: currentPalette.action.selected,
        disabled: currentPalette.action.disabled,
        disabledBackground: currentPalette.action.disabledBackground,
        focus: currentPalette.action.hover,
        hoverOpacity: 0.04,
        selectedOpacity: 0.08,
        disabledOpacity: 0.38,
        focusOpacity: 0.12,
        activatedOpacity: 0.12,
      },
    },
  });

  // Apply scrollbar CSS variables based on theme mode
  useEffect(() => {
    const scrollbarColors = currentPalette.scrollbar;
    
    // Set CSS custom properties for scrollbar colors
    document.documentElement.style.setProperty('--scrollbar-track', scrollbarColors.track);
    document.documentElement.style.setProperty('--scrollbar-thumb', scrollbarColors.thumb);
    document.documentElement.style.setProperty('--scrollbar-thumb-hover', scrollbarColors.thumbHover);
    document.documentElement.style.setProperty('--scrollbar-corner', scrollbarColors.corner);
  }, [themeMode]);

  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
